module.exports = __webpack_public_path__ + "static/media/high-fid-1.8a202848.svg";